import { UPDATE_AVAILABLE_FUNDS } from './actions'
import { combineReducers } from 'redux'
import { reducer as rpp } from './rpp/reducers'
import { reducer as lstu } from './lstu/reducers'

export const availableFunds = (state = [], action) => {
  switch (action.type) {
    case UPDATE_AVAILABLE_FUNDS:
      return action.payload
    default:
      return state
  }
}

// $$FlowFixMe
export const reducer = combineReducers({
  availableFunds,
  lstu,
  rpp,
})
